module.exports = __webpack_public_path__ + "img/microsoft.4af23558.svg";